export const signOut = 'nav-sign-out-btn';
export const newNoteBtn = 'nav-new-note-btn';
